export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/skus/state.js